
export default function Replay() {
    return (
      <div>
        replay page
      </div>
    );
}